import * as t from 'io-ts';

export const googlePlace = t.type({
    placeID: t.string,
    description: t.string,
    structuredFormatting: t.type({
        mainText: t.string,
        secondaryText: t.string,
        mainTextMatchedSubstrings: t.array(
            t.type({
                offset: t.number,
                length: t.number,
            }),
        ),
    }),
});

export type GooglePlace = t.TypeOf<typeof googlePlace>;
